import { defineElement, html, TemplateElement, when } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-tab-group/e-banking-tab-group.js';

class EditableTabGroup extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { mgnlContext: null };
    }

    get headline() {
        return this.content?.headline || '';
    }

    template() {
        return html`
            ${when(
                !this.mgnlContext?.isMagnoliaEdit,
                html`
                    <mb-e-banking-tab-group headline="${this.headline}">
                        <mgnl-editable-area .content="${this.content?.tabElements}"></mgnl-editable-area>
                    </mb-e-banking-tab-group>
                `,
                html` <h2 class="text-xl font-medium text-green-medium mb-8">${this.headline}</h2>
                    <mgnl-editable-area .content="${this.content?.tabElements}"></mgnl-editable-area>`,
            )}
        `;
    }
}

defineElement('editable-tab-group', EditableTabGroup);
